module.exports = __webpack_public_path__ + "feda72d235d55d01b703fc9d4c7b3b35.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/kloudless/icons/onedrivebiz.png
 ** module id = 1479
 ** module chunks = 0
 **/